import {
  SET_SELECTED_SUPPLIER,
  SET_SUPPLIERS,
  SET_SUPPLIERS_LOADED,
  SET_SUPPLIER_FILTER,
  SupplierAction,
  SupplierState,
} from '../types'

const initialState: SupplierState = {
  suppliers: [],
  isSuppliersLoaded: false,
  supplierFilter: {
    name: '',
    address: '',
    phone: '',
  },
}

export const supplierReducer = (
  state = initialState,
  action: SupplierAction
): SupplierState => {
  switch (action.type) {
    case SET_SUPPLIERS:
      return {
        ...state,
        suppliers: action.payload,
      }
    case SET_SUPPLIERS_LOADED:
      return {
        ...state,
        isSuppliersLoaded: action.payload,
      }
    case SET_SUPPLIER_FILTER:
      return {
        ...state,
        supplierFilter: action.payload,
      }
    case SET_SELECTED_SUPPLIER:
      return {
        ...state,
        selectedSupplier: action.payload,
      }
    default:
      return state
  }
}
